import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

// Blank filters are omitted rather than sent as "": the server matches on a
// present userType/status, so an empty string is not the same as "no filter".
export const getCycleMemberships = async (cycleId, filters = {}, page = 1) => {
  const headers = await getAuthHeaders();
  const { search, userType, status } = filters;

  const params = { page };
  if (search) params.search = search;
  if (userType) params.userType = userType;
  if (status) params.status = status;

  const response = await tempMeeApi.get(
    `/awards-service-api/admin/cycles/${cycleId}/memberships`,
    { headers, params },
  );

  return response.data;
};
